import React, { useEffect, useState } from "react";
import ErrorBoundary from "../common/errorBoundary";
import { FormControl, FormLabel } from "@material-ui/core";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as flightDetailsActiona from "../actions/flightDetails";
import * as stationAction from "../actions/stationNames";
import { useHistory } from "react-router-dom";

const styles = {
    stationLabel: {
        color: "white",
        marginLeft: "60%",
        marginBottom: "10%",
    },
    dropdownStation: {
        marginBottom: "10%",
        marginLeft: "60%",
    },
    noflightsTag: {
        marginTop: "10%",
        marginLeft: "60%",
    },
    okButton: {
        marginLeft: "60%",
    },
};

function StationPage(props) {
    const history = useHistory();
    const [stationCode, setStationCode] = useState("");

    useEffect(() => {
        props.actions.getAllStations();
    }, []);

    useEffect(() => {
        props.actions.setSelectedStation(stationCode);
    }, [stationCode]);

    const handleOKClick = () => {
        if (stationCode) {
            history.push("/flights");
        }
    };

    return (
        <ErrorBoundary>
            <FormControl>
                <FormLabel style={styles.stationLabel} htmlFor="uncontrolled-native">
                    Select Station Code
                </FormLabel>
                <select
                    style={styles.dropdownStation}
                    className="browser-default custom-select"
                    // defaultValue=""
                    label="all-station"
                    value={stationCode}
                    onChange={(e) => setStationCode(e.target.value)}
                    data-testid="station-dropdown"
                >
                    <option key="-1" value="">
                        Select Station
                    </option>
                    {props.allStations.map((code, name) => (
                        <option value={code} key={name}>
                            {code}
                        </option>
                    ))}
                </select>
                <button className="btn btn-primary" style={styles.okButton} onClick={() => handleOKClick()}>
                    OK{" "}
                </button>
            </FormControl>
        </ErrorBoundary>
    );
}

const mapStateToProps = (state) => {
    const { filteredFlightDetails, isFetched } = state.flightDetail;
    const { allStations, requestInProgress } = state.StationDetail;

    return {
        allStations,
        filteredFlightDetails,
        isFetched,
        requestInProgress,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, flightDetailsActiona, stationAction), dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StationPage);
